import React from 'react';
import { node } from 'prop-types';
import ErrorView from './ErrorView';
import { ERROR_REPORT_URL } from '../consts';

export default class ErrorBoundary extends React.Component {
	static propTypes = {
		children: node
	};

	state = {
		details: undefined,
		error: undefined
	};

	componentDidCatch(error, info) {
		const details = { info, module: 'visa' };
		this.onError(error, details);
		this.setState({ error, details });
	}

	onError(error, details) {
		if (process.env.NODE_ENV !== 'production' || ERROR_REPORT_URL === 'GATSBY_ERROR_REPORT_URL') {
			console.error(error);
			return;
		}

		const body = {
			name: error.name,
			error: error.toString(),
			stack: error.stack,
			url: document.location.href,
			...details
		};

		return fetch(ERROR_REPORT_URL, {
			method: 'POST',
			body: JSON.stringify(body),
			headers: new Headers({
				'Content-Type': 'application/json'
			})
		});
	}

	render() {
		const { children } = this.props;
		const { error } = this.state;
		if (error) {
			return <ErrorView />;
		}
		return children;
	}
}
